export default __webpack_public_path__ + "static/media/user3.c3fedbfd.jpg";